// Module registry — drives both the sidebar and the generic Register screen.
// Each module: { key, title, endpoint, group, readOnly?, columns:[{key,label,type,options?,list?,form?}] }
// type: text | textarea | number | date | bool | select

const YN = { type: "bool" };
const RISK = { type: "select", options: ["Low", "Medium", "High", "Very High"] };

export const MODULES = [
  // ── Data Inventory ────────────────────────────────────────────────────────
  {
    key: "repositories", title: "Data Repository Register", endpoint: "/repositories", group: "Data Inventory",
    columns: [
      { key: "repo_code", label: "Repo Code" },
      { key: "name", label: "Name" },
      { key: "type", label: "Type" },
      { key: "department", label: "Department" },
      { key: "branch", label: "Branch" },
      { key: "business_owner", label: "Business Owner" },
      { key: "technical_owner", label: "Technical Owner", list: false },
      { key: "server_name", label: "Server", list: false },
      { key: "database_name", label: "Database", list: false },
      { key: "environment", label: "Environment", type: "select", options: ["Production", "UAT", "DR"], list: false },
      { key: "encryption_status", label: "Encryption", type: "select", options: ["Enabled", "Partial", "Disabled", "Unknown"] },
      { key: "contains_personal_data", label: "Personal Data", ...YN },
      { key: "contains_customer_data", label: "Customer Data", ...YN, list: false },
      { key: "sensitive_data_present", label: "Sensitive", ...YN, list: false },
      { key: "cross_border_transfer", label: "Cross Border", ...YN, list: false },
      { key: "third_party_access", label: "3rd-Party Access", ...YN, list: false },
      { key: "risk", label: "Risk", ...RISK },
      { key: "last_review_date", label: "Last Review", type: "date", list: false },
      { key: "next_review_date", label: "Next Review", type: "date", list: false },
      { key: "status", label: "Status", type: "select", options: ["Active", "Review Required", "Retired"] },
      { key: "description", label: "Description", type: "textarea", list: false },
    ],
  },
  {
    key: "data-categories", title: "Data Category Master", endpoint: "/data-categories", group: "Data Inventory",
    columns: [
      { key: "name", label: "Category" },
      { key: "is_sensitive", label: "Sensitive", ...YN },
      { key: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
      { key: "description", label: "Description", type: "textarea", list: false },
    ],
  },
  {
    key: "data-fields", title: "Personal Data Field Register", endpoint: "/data-fields", group: "Data Inventory",
    columns: [
      { key: "field_name", label: "Field" },
      { key: "classification", label: "Classification", type: "select", options: ["Personal Data", "High-Risk Personal Data", "Financial Data", "Biometric", "Health Data", "Confidential"] },
      { key: "category_id", label: "Category ID", type: "number" },
      { key: "is_mandatory", label: "Mandatory", ...YN },
      { key: "masking_required", label: "Masking", ...YN },
      { key: "encryption_required", label: "Encryption", ...YN },
    ],
  },
  {
    key: "applications", title: "Application Inventory", endpoint: "/applications", group: "Data Inventory",
    columns: [
      { key: "name", label: "Application" }, { key: "version", label: "Version" }, { key: "vendor", label: "Vendor" },
      { key: "owner", label: "Owner" }, { key: "database_name", label: "Database", list: false },
      { key: "api_available", label: "API", ...YN }, { key: "personal_data", label: "Personal Data", ...YN },
      { key: "risk_rating", label: "Risk", ...RISK }, { key: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
    ],
  },
  {
    key: "databases", title: "Database Inventory", endpoint: "/databases", group: "Data Inventory",
    columns: [
      { key: "name", label: "Database" }, { key: "type", label: "Type" }, { key: "server", label: "Server" },
      { key: "port", label: "Port", type: "number", list: false }, { key: "environment", label: "Env", list: false },
      { key: "num_tables", label: "Tables", type: "number" }, { key: "personal_data_tables", label: "PII Tables", type: "number" },
      { key: "encryption", label: "Encryption" }, { key: "backup", label: "Backup", list: false }, { key: "last_scan", label: "Last Scan", type: "date", list: false },
    ],
  },
  {
    key: "pii-map", title: "PII Data Map (Discovery)", endpoint: "/pii-discovery", group: "Data Inventory", readOnly: true, plain: true,
    columns: [
      { key: "host", label: "Host" }, { key: "location", label: "Location" }, { key: "data_type", label: "Data Type" },
      { key: "match_count", label: "Matches" }, { key: "encryption_status", label: "Encryption" }, { key: "risk", label: "Risk" },
      { key: "confidence", label: "Confidence" }, { key: "source", label: "Source" }, { key: "scanned_at", label: "Scanned" },
    ],
  },

  // ── Consent ─────────────────────────────────────────────────────────────
  {
    key: "consent-purposes", title: "Purpose Management", endpoint: "/consent/purposes", group: "Consent",
    columns: [
      { key: "code", label: "Code" }, { key: "name", label: "Purpose" },
      { key: "category", label: "Category", type: "select", options: ["Banking", "Marketing", "Operations"] },
      { key: "business_owner", label: "Owner" }, { key: "is_mandatory", label: "Mandatory", ...YN }, { key: "is_active", label: "Active", ...YN },
      { key: "description", label: "Description", type: "textarea", list: false },
    ],
  },
  {
    key: "consent-register", title: "Consent Register", endpoint: "/consent/register", group: "Consent",
    columns: [
      { key: "customer_ref", label: "CIF" }, { key: "customer_name", label: "Name" }, { key: "mobile", label: "Mobile" },
      { key: "email", label: "Email", list: false }, { key: "branch", label: "Branch" }, { key: "purpose_id", label: "Purpose ID", type: "number" },
      { key: "channel", label: "Channel", type: "select", options: ["Branch", "Website", "Mobile App", "Internet Banking", "SMS", "Email", "QR", "API"] },
      { key: "status", label: "Status", type: "select", options: ["Active", "Withdrawn", "Expired"] },
      { key: "consent_date", label: "Consent Date", type: "date" }, { key: "expiry_date", label: "Expiry", type: "date", list: false },
    ],
  },
  {
    key: "consent-templates", title: "Consent Templates", endpoint: "/consent/templates", group: "Consent",
    columns: [
      { key: "name", label: "Name" },
      { key: "channel", label: "Channel", type: "select", options: ["Onboarding", "Loan", "Marketing", "WhatsApp", "Email", "SMS", "Mobile Banking", "Internet Banking", "Website"] },
      { key: "language", label: "Language" }, { key: "version", label: "Version", type: "number" },
      { key: "status", label: "Status", type: "select", options: ["Draft", "Approved", "Active", "Retired"] },
      { key: "approval_date", label: "Approved", type: "date", list: false }, { key: "effective_date", label: "Effective", type: "date" },
      { key: "content", label: "Content", type: "textarea", list: false },
    ],
  },
  {
    key: "cookie-categories", title: "Cookie Categories", endpoint: "/cookie/categories", group: "Consent",
    columns: [
      { key: "name", label: "Category" }, { key: "is_mandatory", label: "Mandatory", type: "bool" },
      { key: "is_active", label: "Active", type: "bool" }, { key: "description", label: "Description", type: "textarea", list: false },
    ],
  },
  {
    key: "cookie-consents", title: "Cookie Consent Log", endpoint: "/cookie/consents", group: "Consent", readOnly: true,
    columns: [
      { key: "visitor_id", label: "Visitor" }, { key: "ip", label: "IP" }, { key: "categories", label: "Accepted" },
      { key: "accepted_all", label: "All", type: "bool" }, { key: "page_url", label: "Page" }, { key: "created_at", label: "When", type: "date" },
    ],
  },

  // ── Rights / Grievances / Breach ────────────────────────────────────────
  {
    key: "rights", title: "Data Principal Rights", endpoint: "/rights", group: "Rights & Requests",
    columns: [
      { key: "request_no", label: "Request No" }, { key: "customer_ref", label: "CIF" }, { key: "customer_name", label: "Name" },
      { key: "type", label: "Type", type: "select", options: ["Access", "Correction", "Erasure", "Nomination", "Consent Withdrawal"] },
      { key: "status", label: "Status", type: "select", options: ["Submitted", "Verification", "Approved", "Action", "Closed", "Rejected"] },
      { key: "branch", label: "Branch", list: false }, { key: "assigned_to", label: "Assigned To", list: false },
      { key: "sla_due_at", label: "SLA Due", type: "date" }, { key: "details", label: "Details", type: "textarea", list: false },
    ],
  },
  {
    key: "grievances", title: "Grievance Management", endpoint: "/grievances", group: "Rights & Requests",
    columns: [
      { key: "complaint_no", label: "Complaint No" }, { key: "customer_name", label: "Customer" }, { key: "category", label: "Category" },
      { key: "subject", label: "Subject" }, { key: "priority", label: "Priority", ...RISK },
      { key: "status", label: "Status", type: "select", options: ["Open", "In Progress", "Closed"] },
      { key: "assigned_to", label: "Assigned To", list: false }, { key: "sla_due_at", label: "SLA Due", type: "date" },
      { key: "description", label: "Description", type: "textarea", list: false }, { key: "resolution", label: "Resolution", type: "textarea", list: false },
    ],
  },
  {
    key: "breaches", title: "Data Breach / Incidents", endpoint: "/breaches", group: "Rights & Requests",
    columns: [
      { key: "ref_no", label: "Ref No" }, { key: "title", label: "Title" },
      { key: "severity", label: "Severity", ...RISK }, { key: "affected_customers", label: "Affected", type: "number" },
      { key: "detected_at", label: "Detected", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["Open", "Investigation", "Contained", "Closed"] },
      { key: "systems_affected", label: "Systems", list: false }, { key: "data_affected", label: "Data", list: false },
      { key: "root_cause", label: "Root Cause", type: "textarea", list: false }, { key: "remediation", label: "Remediation", type: "textarea", list: false },
      { key: "reported_by", label: "Reported By", list: false },
    ],
    rowActions: [
      { label: "Report PDF", build: (r) => ({ path: `/evidence/breach/${r.id}/report.pdf`, filename: `breach-${r.ref_no || r.id}-report.pdf` }) },
      { label: "Evidence ZIP", build: (r) => ({ path: `/evidence/breach/${r.id}/package.zip`, filename: `breach-${r.ref_no || r.id}-evidence.zip` }) },
    ],
  },

  // ── Governance registers ─────────────────────────────────────────────────
  {
    key: "vendors", title: "Vendor / Third-Party Register", endpoint: "/vendors", group: "Governance",
    columns: [
      { key: "name", label: "Vendor" }, { key: "agreement", label: "Agreement" }, { key: "dpa_available", label: "DPA", ...YN },
      { key: "iso27001", label: "ISO27001", ...YN, list: false }, { key: "soc2", label: "SOC2", ...YN, list: false }, { key: "pci_dss", label: "PCI DSS", ...YN, list: false },
      { key: "data_shared", label: "Data Shared", list: false }, { key: "risk_level", label: "Risk", ...RISK },
      { key: "expiry_date", label: "Expiry", type: "date" }, { key: "review_date", label: "Review", type: "date", list: false },
      { key: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
    ],
  },
  {
    key: "data-sharing", title: "Third-Party Data Sharing", endpoint: "/data-sharing", group: "Governance",
    columns: [
      { key: "shared_with", label: "Shared With" }, { key: "purpose", label: "Purpose" }, { key: "legal_basis", label: "Legal Basis" },
      { key: "agreement_ref", label: "Agreement", list: false }, { key: "cross_border", label: "Cross Border", ...YN },
      { key: "encryption", label: "Encryption", list: false }, { key: "shared_from", label: "From", type: "date" }, { key: "shared_until", label: "Until", type: "date", list: false },
      { key: "is_active", label: "Active", ...YN }, { key: "data_categories", label: "Data Categories", type: "textarea", list: false },
    ],
  },
  {
    key: "retention", title: "Retention & Disposal", endpoint: "/retention", group: "Governance",
    columns: [
      { key: "category", label: "Category" }, { key: "repository", label: "Repository" }, { key: "retention_period", label: "Retention" },
      { key: "disposal_method", label: "Disposal Method" }, { key: "next_disposal_date", label: "Next Disposal", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["Active", "Disposed"] },
    ],
  },
  {
    key: "risks", title: "Privacy Risk Register", endpoint: "/risks", group: "Governance",
    columns: [
      { key: "risk", label: "Risk" }, { key: "likelihood", label: "Likelihood", ...RISK }, { key: "impact", label: "Impact", ...RISK },
      { key: "residual_risk", label: "Residual", ...RISK }, { key: "owner", label: "Owner" }, { key: "due_date", label: "Due", type: "date" },
      { key: "status", label: "Status", type: "select", options: ["Open", "Mitigating", "Closed"] },
      { key: "control", label: "Control", type: "textarea", list: false },
    ],
  },

  // ── Discovery ────────────────────────────────────────────────────────────
  {
    key: "discovery-scans", title: "Discovery Scans", endpoint: "/discovery/scans", group: "Discovery",
    columns: [
      { key: "scan_ref", label: "Scan Ref" }, { key: "source", label: "Source" }, { key: "repository", label: "Repository" },
      { key: "records_scanned", label: "Records", type: "number" }, { key: "personal_found", label: "Personal", type: "number" },
      { key: "sensitive_found", label: "Sensitive", type: "number" }, { key: "false_positives", label: "False +ve", type: "number", list: false },
      { key: "confidence", label: "Confidence %", type: "number" },
      { key: "status", label: "Status", type: "select", options: ["Running", "Completed", "Failed"] },
      { key: "started_at", label: "Started", type: "date", list: false }, { key: "finished_at", label: "Finished", type: "date", list: false },
    ],
  },
  {
    key: "classification-rules", title: "Classification Rules", endpoint: "/discovery/rules", group: "Discovery",
    columns: [
      { key: "rule_type", label: "Rule Type", type: "select", options: ["customer_dict", "asset_dict", "source_high", "source_low", "include", "exclude"] },
      { key: "pattern", label: "Pattern / Keyword" }, { key: "weight", label: "Weight", type: "number" },
      { key: "is_active", label: "Active", type: "bool" }, { key: "notes", label: "Notes", list: false },
    ],
  },

  // ── Governance ───────────────────────────────────────────────────────────
  {
    key: "ropa", title: "Record of Processing (RoPA)", endpoint: "/ropa", group: "Governance",
    columns: [
      { key: "activity_name", label: "Activity" }, { key: "department", label: "Department" },
      { key: "purpose", label: "Purpose" }, { key: "data_principal", label: "Data Principal", type: "select", options: ["Customer", "Employee", "Vendor", "Director", "Nominee"] },
      { key: "legal_basis", label: "Legal Basis" }, { key: "recipients", label: "Recipients", list: false },
      { key: "third_party_sharing", label: "3rd-Party", type: "bool" }, { key: "international_transfer", label: "Intl Transfer", type: "bool", list: false },
      { key: "retention", label: "Retention", list: false }, { key: "security_controls", label: "Security Controls", type: "textarea", list: false },
      { key: "risk_rating", label: "Risk", type: "select", options: ["Low", "Medium", "High", "Very High"] },
      { key: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
      { key: "data_categories", label: "Data Categories", type: "textarea", list: false },
    ],
  },
  {
    key: "controls", title: "Control Library", endpoint: "/controls", group: "Governance",
    columns: [
      { key: "control_id", label: "Control ID" }, { key: "control", label: "Control" },
      { key: "regulations", label: "Regulations" }, { key: "category", label: "Category" },
      { key: "status", label: "Status", type: "select", options: ["Implemented", "Partial", "Pending"] },
      { key: "description", label: "Description", type: "textarea", list: false },
    ],
  },
  {
    key: "checklist", title: "Compliance Checklist", endpoint: "/checklist", group: "Governance",
    columns: [
      { key: "category", label: "Category" }, { key: "item", label: "Item" },
      { key: "status", label: "Status", type: "select", options: ["Pending", "Compliant", "Non-Compliant", "NA"] },
      { key: "compliance_pct", label: "%", type: "number" }, { key: "owner", label: "Owner", list: false },
      { key: "evidence", label: "Evidence", type: "textarea", list: false }, { key: "comments", label: "Comments", type: "textarea", list: false },
    ],
  },
  {
    key: "calendar", title: "Compliance Calendar (tasks)", endpoint: "/calendar", group: "Governance",
    columns: [
      { key: "task", label: "Task" },
      { key: "category", label: "Category", type: "select", options: ["Policy", "Training", "Audit", "Vendor", "Risk", "Retention", "PIA"] },
      { key: "frequency", label: "Frequency", type: "select", options: ["One-time", "Monthly", "Quarterly", "Half-Yearly", "Annual"] },
      { key: "owner", label: "Owner" }, { key: "due_date", label: "Due", type: "date" }, { key: "last_done", label: "Last Done", type: "date", list: false },
      { key: "reminder_days", label: "Reminder (days)", type: "number", list: false },
      { key: "status", label: "Status", type: "select", options: ["Pending", "Done", "Overdue"] },
      { key: "notes", label: "Notes", type: "textarea", list: false },
    ],
  },
  {
    key: "obligations", title: "Regulatory Obligations", endpoint: "/obligations", group: "Governance",
    columns: [
      { key: "obligation", label: "Obligation" },
      { key: "regulation", label: "Regulation", type: "select", options: ["DPDP Act", "DPDP Rules", "RBI", "CERT-In", "ISO 27001", "ISO 27701", "PCI DSS"] },
      { key: "reference", label: "Reference" }, { key: "control_id", label: "Control" }, { key: "owner", label: "Owner", list: false },
      { key: "status", label: "Status", type: "select", options: ["Open", "In Progress", "Met", "N/A"] },
      { key: "due_date", label: "Due", type: "date" }, { key: "description", label: "Description", type: "textarea", list: false },
    ],
  },

  // ── Admin ────────────────────────────────────────────────────────────────
  {
    key: "audit-log", title: "Audit Log", endpoint: "/audit", group: "Administration", readOnly: true,
    columns: [
      { key: "at", label: "When", type: "date" }, { key: "actor", label: "Actor" }, { key: "actor_scope", label: "Scope" },
      { key: "action", label: "Action" }, { key: "target", label: "Target" }, { key: "ip", label: "IP" },
    ],
  },
  {
    key: "report-schedules", title: "Scheduled Reports", endpoint: "/report-schedules", group: "Admin",
    columns: [
      { key: "name", label: "Name" }, { key: "report_key", label: "Report Key" },
      { key: "format", label: "Format", type: "select", options: ["csv", "xlsx", "pdf"] },
      { key: "frequency", label: "Frequency", type: "select", options: ["Daily", "Weekly", "Monthly"] },
      { key: "recipients", label: "Recipients" }, { key: "is_active", label: "Active", type: "bool" },
      { key: "last_run", label: "Last Run", type: "date", form: false },
      { key: "filters", label: "Filters (JSON)", type: "textarea", list: false },
    ],
  },
  {
    key: "notifications", title: "Notification Log", endpoint: "/notifications", group: "Admin", readOnly: true,
    columns: [
      { key: "created_at", label: "When", type: "date" }, { key: "type", label: "Type" }, { key: "channel", label: "Channel" },
      { key: "recipients", label: "Recipients" }, { key: "subject", label: "Subject" }, { key: "status", label: "Status" },
    ],
  },
  {
    key: "roles", title: "Roles", endpoint: "/roles", group: "Admin",
    columns: [
      { key: "name", label: "Role" }, { key: "description", label: "Description" },
      { key: "is_system", label: "System", type: "bool" },
      { key: "permissions", label: "Permissions (JSON)", type: "textarea", list: false },
    ],
  },
  {
    key: "user-roles", title: "User Role Assignments", endpoint: "/user-roles", group: "Admin",
    columns: [
      { key: "user_key", label: "User (email / username)" }, { key: "role", label: "Role" }, { key: "note", label: "Note", list: false },
    ],
  },
  {
    key: "workflow-config", title: "Workflow Config", endpoint: "/workflow-config", group: "Admin",
    columns: [
      { key: "module", label: "Module", type: "select", options: ["repositories", "consent-register", "consent-templates", "rights", "grievances", "breaches", "vendors", "retention", "data-sharing", "risks", "ropa", "controls", "obligations"] },
      { key: "enabled", label: "Maker-checker", type: "bool" }, { key: "note", label: "Note", list: false },
    ],
  },
];

// Register key → reporting-engine key (enables Export buttons on that register).
export const REPORT_KEY = {
  repositories: "data-repositories", "data-fields": "personal-data-fields", applications: "applications",
  "consent-register": "consent-register", rights: "privacy-requests", grievances: "grievances",
  breaches: "breaches", vendors: "vendors", retention: "retention", risks: "risks", "pii-map": "pii-findings",
  ropa: "ropa", controls: "controls", checklist: "checklist", calendar: "calendar", obligations: "obligations",
  "consent-templates": "consent-templates", "cookie-consents": "cookie-consents",
};

// Dedicated (non-register) pages, shown in the sidebar under their group.
export const SPECIAL = [
  { key: "bulk-consent", title: "Bulk Consent Import", group: "Consent", path: "/consent-bulk" },
  { key: "compliance", title: "Compliance Score", group: "Governance", path: "/compliance" },
  { key: "calendar-view", title: "Compliance Calendar", group: "Governance", path: "/calendar" },
  { key: "policies", title: "Policies & Notices", group: "Governance", path: "/policies" },
  { key: "pia", title: "PIA / DPIA Assessment", group: "Assessments", path: "/pia" },
  { key: "estate", title: "Discovery Overview", group: "Discovery", path: "/estate" },
  { key: "machines", title: "Machines", group: "Discovery", path: "/machines" },
  { key: "estate-scans", title: "Scans", group: "Discovery", path: "/estate-scans" },
  { key: "findings", title: "Files & Findings", group: "Discovery", path: "/findings" },
  { key: "unencrypted", title: "Unencrypted Personal Data", group: "Discovery", path: "/unencrypted" },
  { key: "agent-servers", title: "Agent Servers", group: "Discovery", path: "/agent-servers" },
  { key: "discovery", title: "Data Discovery & Classification", group: "Discovery", path: "/discovery" },
  { key: "reports", title: "Reports & Export", group: "Reports", path: "/reports" },
  { key: "support-access", title: "Vxaro Support Access", group: "Admin", path: "/support-access" },
  { key: "workflow", title: "Approval Inbox", group: "Admin", path: "/workflow" },
];

export const MODULE_BY_KEY = Object.fromEntries(MODULES.map((m) => [m.key, m]));

export const GROUPS = MODULES.reduce((acc, m) => {
  (acc[m.group] = acc[m.group] || []).push(m);
  return acc;
}, {});
